// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__168ao","title":"BackImages_title__35CUs","images":"BackImages_images__1iVRq"};